const PATH = 'fe.components.reliability_test.not_pass_message';

const messages = {
  message: {
    key: `${PATH}.message`,
    defaultValue: `Unfortunately you <span style="color: #D01E08">did not pass</span> the`
  }
};

export default messages;
